// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Benefits_wrapper__P6bfR","heading":"Benefits_heading__s9hRP","description":"Benefits_description__8TjFW","benefitsGrid":"Benefits_benefitsGrid__kHxeb"};